import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className={className}
        >
          <path d="M26.962 11.77c.016-.256.038-.51.038-.77 0-6.066-4.936-11-11-11S5 4.934 5 11c0 .26.022.514.038.77C2.012 13.73 0 17.132 0 21c0 6.066 4.936 11 11 11 1.802 0 3.498-.444 5-1.214A10.925 10.925 0 0021 32c6.064 0 11-4.934 11-11 0-3.868-2.012-7.27-5.038-9.23zM16 2c4.88 0 8.842 3.908 8.976 8.756A10.915 10.915 0 0021 10c-1.802 0-3.498.444-5 1.214A10.925 10.925 0 0011 10c-1.402 0-2.74.274-3.976.756C7.158 5.908 11.12 2 16 2zm0 11.524a9.021 9.021 0 013.798 5.606A8.895 8.895 0 0116 20a8.895 8.895 0 01-3.798-.87A9.016 9.016 0 0116 13.524zm-5.576 4.486c-1.602-1.278-2.782-3.064-3.222-5.14A8.895 8.895 0 0111 12c1.048 0 2.038.214 2.974.544a11.035 11.035 0 00-3.55 5.466zm7.602-5.466C18.962 12.214 19.952 12 21 12c1.362 0 2.64.326 3.798.87-.44 2.076-1.62 3.86-3.222 5.138a11.038 11.038 0 00-3.55-5.464zM11 30c-4.962 0-9-4.038-9-9 0-2.848 1.354-5.358 3.424-7.01a11.035 11.035 0 004.614 6.24c-.016.256-.038.51-.038.77 0 3.396 1.548 6.436 3.974 8.456-.936.33-1.926.544-2.974.544zm5-1.524a8.992 8.992 0 01-3.976-7.232C13.26 21.726 14.598 22 16 22c1.402 0 2.74-.274 3.976-.756A8.992 8.992 0 0116 28.476zM21 30c-1.048 0-2.038-.214-2.974-.544A10.983 10.983 0 0022 21c0-.26-.022-.514-.038-.77a11.035 11.035 0 004.614-6.24C28.646 15.642 30 18.152 30 21c0 4.962-4.038 9-9 9z"></path>
        </svg>
    );
};
